export default __webpack_public_path__ + "static/gmail-chrome-extension-f82acf6929d8cdd7f7c5ef67ac52ba49.svg";